import React, { useState, useEffect } from 'react';
import supabase from '../supabaseClient';
import './resetpasswordstyles.css'; // Import your CSS file

const ResetPass = () => {
  const [newPassword, setNewPassword] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Extract the token from the URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token'); // Adjust the parameter name if different

    if (accessToken) {
      // Set the token in state or handle it as needed
      setLoading(false);
    } else {
      setMessage('Invalid or missing token.');
      setLoading(false);
    }
  }, []);

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Extract the token from the URL query parameters
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get('access_token'); // Adjust the parameter name if different

    if (accessToken) {
      const { error } = await supabase.auth.api.updateUser(accessToken, {
        password: newPassword,
      });

      if (error) {
        setMessage(`Error: ${error.message}`);
      } else {
        setMessage('Password successfully reset! You can now log in with your new password.');
      }
    } else {
      setMessage('Invalid or expired token.');
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="reset-password-container">
      <h2 className="reset-password-title">Reset Your Password</h2>
      <form onSubmit={handleResetPassword} className="reset-password-form">
        <input
          type="password"
          placeholder="Enter your new password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          className="reset-password-input"
        />
        <button type="submit" className="reset-password-button">
          Reset Password
        </button>
      </form>
      {message && <p className="reset-password-message">{message}</p>}
    </div>
  );
};

export default ResetPass;
